module.exports = __webpack_public_path__ + "img/logo.4fe79ae3.png";